import { render, staticRenderFns } from "./RequestDocuments.vue?vue&type=template&id=cdde10b6"
import script from "./RequestDocuments.vue?vue&type=script&lang=js"
export * from "./RequestDocuments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports